import { t } from '@lingui/macro';

// Error if length is not 8
export const validateCompanyCvr = (value: string) =>
    value?.length === 8 ? undefined : t`Please set a valid Co. reg. no. Update it in master information`;

// Error if field is empty
export const validateCompanyName = (value: string) =>
    value ? undefined : t`Company name is required. Update it in master information`;
